export const createOptions = (data: any[], key: string) => {
  if (!data) return [];
  const options = data[0]?.[key]?.map((option: { id: number, name: string }) => ({
    value: option.id >= 0 ? option.id : option,
    label: option.name || option,
  }));

  options &&
    options
      .sort((a: { value: string, label: string }, b: { value: string, label: string }) => a.label.localeCompare(b.label))
      .unshift({ value: "", label: "Все" });

  return options;
};

export const createMultiOptions = (data: { id: number, name: string }[]) => {
  if (!data) return [];
  const options = data.map((option: { id: number, name: string }) => ({
    value: option.id,
    label: option.name,
  }));

  return options;
};

export const createSelectOptions = (data: { [key: string]: string }[]) => {
  if (!data) return [];
  const options = data.map((el: { [key: string]: string }) => ({
    value: Object.keys(el).toString(),
    label: Object.values(el).toString()
  }));
  options.unshift({ value: "", label: "Все" });

  return options;
};

export const createMultiselectOptionsByList = (data: { id?: string, first?: string, second?: string, name?: string }[] = []) => {
  const options = data.map((item) => ({
    value: item.first || item.id || '',
    label: item.second || item.name || ''
  }));

  return options;
};

export const createMultiselectOptionsByPos = (data: {
  id: string,
  name: string,
  retail_chain_id?: string,
  region_id: string,
  area_id: string
}[] = []) => {
  const options = data.map((item) => ({
    value: item.id,
    label: item.name,
    chain: item.retail_chain_id,
    region: item.region_id,
    area: item.area_id
  }));

  return options;
};

export const createMultiselectOptionsBychains = (data: {
  id: string,
  name: string,
  region_id: string,
  area_id: string
}[] = []) => {
  const optionsMap = new Map();

  data.forEach((item) => {
    const key = item.id;

    if (!optionsMap.has(key)) {
      optionsMap.set(key, {
        value: item.id,
        label: item.name,
        regions: [item.region_id],
      });
    } else {

      const existingOption = optionsMap.get(key);
      if (!existingOption.regions.includes(item.region_id)) {
        existingOption.regions.push(item.region_id);
      }
    }
  });

  const options = Array.from(optionsMap.values());

  return options;
};
